import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import UiMessageCodeHelpers from 'shared/utils/UiMessageCodeHelpers';
import { RED, WHITE } from '../../Styles';
import { StyledButton } from '../Styles';

export const DisableClerkDebuggingButton = observer(() => {
  const {
    AuctionStore: { getAuctionLaneIdForInvocation },
    BidStore: {
      auction: { monitorChatOnly },
    },
    WebSocketStore: { sendMessage },
  } = useStores();

  if (!monitorChatOnly) return null;

  return (
    <StyledButton
      bgColor={RED}
      color={WHITE}
      onClick={() => {
        sendMessage({
          method: 'UiMessageToClerks',
          payload: [
            getAuctionLaneIdForInvocation,
            UiMessageCodeHelpers.getUiStateResult(
              UiMessageCodeHelpers.uiMessageState.DebuggingErrorsOff,
            ).value,
          ],
        });
      }}
      style={{ cursor: 'pointer' }}
    >
      Remote Debugging Off
    </StyledButton>
  );
});

export default DisableClerkDebuggingButton;
